export const getResumableRequestBooking = (
  queueSlotId: string | null,
  requestedTime: string | null
) => {
  if (queueSlotId === null || requestedTime === null) {
    return null;
  }

  return { queueSlotId, requestedTime };
};
